// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
// import './assets/css/mian.css'
import scroll from 'vue-seamless-scroll'
import App from './App'
import router from './router'
import db from './api/db'
import url from './config/url'
import Vuex from 'vuex'
import store from './store'
import { getTemplate, channelGoto } from './api/func.js'
import MetaInfo from 'vue-meta-info'
import { wsUrl, moblieUrl } from '@/config/index'
import { dateToConver } from './libs/tools.js'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import VueUeditorWrap from 'vue-ueditor-wrap'
import SlideVerify from 'vue-monoplasty-slide-verify';
import WtDataModal from './components/Public/dataModal/dataModal'
import vshare from 'vshare'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import '../node_modules/vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import '../node_modules/swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)
Vue.use(WtDataModal)
Vue.use(SlideVerify);
Vue.use(VueDirectiveImagePreviewer)
Vue.use(Vuex)
Vue.use(db)
Vue.use(ElementUI)
Vue.use(scroll);
Vue.component('vue-ueditor-wrap', VueUeditorWrap)
Vue.use(vshare);
Vue.use(MetaInfo)

import Share from 'vue-social-share'
// import '@/assets/css/client.css';
import '@/assets/css/client.css'
Vue.use(Share)

//路由页面
Vue.prototype.$url = url;
Vue.config.productionTip = false
Vue.prototype.getTemplate = getTemplate
Vue.prototype.channelGoto = channelGoto
Vue.prototype.$moblieUrl = moblieUrl
Vue.prototype.$dateToConver = dateToConver

// Vue.prototype.$wsUrl  ='ws://192.168.31.14:2346';
// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
import VueLazyLoad from 'vue-lazyload'


router.beforeEach((to, from, next) => {
  // chrome
  // document.body.scrollTop = 0
  // // firefox
  // document.documentElement.scrollTop = 0
  // // safari
  // window.pageYOffset = 0
  next()
  db.get(url.webconfigInfo).then(resp => {
    store.state.webconfigInfo = resp.data
  }).then(() => {
    Vue.use(VueLazyLoad, {
      attempt: 1,
      error: store.state.webconfigInfo.default_pic_text ? store.state.webconfigInfo.default_pic_text.url : '',
    })
  }).catch(err => {
    console.log(err);
  });

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  // 添加mounted，不然不会执行预编译
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js